var _rect, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 39.126,
    viewBox: "0 0 152 39.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 26.666,
    height: 26.666,
    transform: "translate(81.063 0.707) rotate(45)",
    fill: "#020202",
    stroke: "#24b8c0",
    strokeWidth: 1,
    opacity: 0.499
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 63,
    transform: "translate(0 19.5)",
    fill: "#020202",
    stroke: "#24b8c0",
    strokeWidth: 1,
    opacity: 0.499
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 52,
    transform: "translate(100 19.5)",
    fill: "#020202",
    stroke: "#24b8c0",
    strokeWidth: 1,
    opacity: 0.499
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.0ba65eccd177c72d9da60e974c901d6e.svg";
export { ForwardRef as ReactComponent };